import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormStepComponentV1 } from './form-step-v1/form-step.component-v1';
import { FormDynamicComponentV1 } from './form-dynamic-v1/form-dynamic-v1.component';
import { ContentfulService } from '../_services/contentful.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterpolatePipe } from '../_pipes/interpolate.pipe';
import { ToolsModule } from '../tools/tools.module';
import { AddressSearchComponent } from '../tools/address-search/address-search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';


@NgModule({
  declarations: [
    FormStepComponentV1,
    FormDynamicComponentV1
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    InterpolatePipe,
    ToolsModule,
    ReactiveFormsModule,
    GoogleMapsModule
  ],
  exports: [
    FormStepComponentV1,
    FormDynamicComponentV1
  ],
  providers: [ContentfulService]
})
export class FormsManagementModule { }
